export default {
  intouchCap: {
    currentOrgDetails: {},
    user: {},
    sidebarMenuData: [],
    topbarMenuData: [],
    fetchingUserdata: false,
    getLastSyncTimeStatus: '',
    lastSyncTime: '',
    lastSyncTimeError: null,
    getBeamerPostsExploreStatus: '',
    beamerPostsExplore: [],
    getBeamerPostsExploreError: null,
    getBeamerPostsNotificationStatus: '',
    beamerPostsNotification: [],
    getBeamerPostsNotificationError: null,
  },
};
